<script setup>
const props = defineProps({
	position: Object, //position in 2d Sreen
	color: String,
});
</script>


<template>
  <div class="container" :style="styles" @pointerdown="startDrag" @click="onClick">    
      <slot></slot>
  </div>
</template>

<script>
export default {
name: "DragableContainer",
mounted() {
  this.sectionDialogX = this.position.x;
  this.sectionDialogY = this.position.y;
},
data: () => ({
  dialogIndrag: false,
  sectionDialogX: 50,
  sectionDialogY: 50,
  dialoginitialLeft: 0,
  dialoginitialTop: 0,
  dragStartX: 0,
  dragStartY: 0,
}),
methods: {
  startDrag(e) {
    // exit if clicking on interactive elements
    const interactiveTags = ['INPUT', 'BUTTON', 'TEXTAREA', 'SELECT', 'LABEL', 'A'];
    if (interactiveTags.includes(e.target.tagName)) {
      return;
    }
    // check for classes of interactive vuetify components
    if (e.target.closest('.v-text-field') || 
        e.target.closest('.v-input') || 
        e.target.closest('.v-btn') ||
        e.target.closest('button') || 
        e.target.closest('input') ||
        e.target.closest('textarea')) {
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    this.dialogIndrag = true;
    document.addEventListener("pointermove", this.drag);
    document.addEventListener("pointerup", this.endDrag);
    this.dragStartX = e.pageX;
    this.dragStartY = e.pageY;
    this.dialoginitialLeft = this.sectionDialogX;
    this.dialoginitialTop = this.sectionDialogY;
  },
  drag(e) {
    e.stopImmediatePropagation();
    if (this.dialogIndrag) {
      this.sectionDialogX =
        this.dialoginitialLeft + e.pageX - this.dragStartX;
      this.sectionDialogY = this.dialoginitialTop + e.pageY - this.dragStartY;
    }
  },
  endDrag(e) {
    this.dialogIndrag = false;
    document.removeEventListener("pointermove", this.drag);
    document.removeEventListener("pointerup", this.endDrag);
    e.preventDefault();
    e.stopImmediatePropagation();
  },
  onClick(e) {
    const interactiveTags = ['INPUT', 'BUTTON', 'TEXTAREA', 'SELECT', 'LABEL', 'A'];
    const isInteractive = interactiveTags.includes(e.target.tagName) ||
      e.target.closest('.v-text-field') || 
      e.target.closest('.v-input') || 
      e.target.closest('.v-btn') ||
      e.target.closest('button') || 
      e.target.closest('input') ||
      e.target.closest('textarea');
    
    if (isInteractive) {
      // Allow interactive element events to propagate naturally
      return;
    }
    
    // For non-interactive areas, just prevent default drag behavior
    e.preventDefault();
    e.stopImmediatePropagation();
  },
},
created: () => {},
computed: {
  styles() {
    return {
      left: this.sectionDialogX + "px",
      top: this.sectionDialogY + "px",
      cursor: this.dialogIndrag ? "move" : "pointer",
    };
  },
},
};
</script>

<style lang="scss" scoped>
.container {
position: absolute;
box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.2);
background-color: #fff;
z-index: 9999999;
width: 100%;
}
</style>
